import React, { useMemo, useState } from 'react';
import css from './FilterSidebar.module.css';
import FilterSectionHeader from './FilterSectionHeader';
import SearchInput from './SearchInput';
import classNames from 'classnames';
const TalentLevelFilterSection = ({
  handleClearFilter,
  handleCheckboxChange,
  talentFilterOptions,
  paramKey,
  selectedValues,
  isBlackBgFilter,
  isTalentOfferingFilters,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };

  // Memoized filtering for performance
  const filteredTalentTypes = useMemo(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return talentFilterOptions.filter(({ value }) => value.toLowerCase().includes(lowerSearchTerm));
  }, [searchTerm, talentFilterOptions]);

  const displayedTalentLevels = filteredTalentTypes.slice(0, 10);

  return (
    <div
      className={classNames(
        css.filterSection,
        isTalentOfferingFilters ? css.talentOfferingFilters : null
      )}
    >
      {!isTalentOfferingFilters && (
        <FilterSectionHeader
          isBlackBgFilter={isBlackBgFilter}
          titleId={'FilterCategories.levelOfTalent'}
          handleClear={handleClear}
        />
      )}
      <SearchInput
        type="text"
        className={css.searchInput}
        placeholder="Search Talent Level..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />
      <div className={css.scrollable}>
        {displayedTalentLevels.map(item => {
          const lowerValue = item.value.toLowerCase();
          const isChecked = selectedValues.includes(lowerValue);
          return (
            <label key={item.value} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={lowerValue}
                onChange={e => handleCheckboxChange(e, paramKey)}
                checked={isChecked}
              />
              <span>{item.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default TalentLevelFilterSection;
